<template>
  <el-container>
    <el-header>
      <img :src="getLogo ? getLogo : require('@/assets/img/logo.png')" class="logo">
      <div style="display: flex; align-items: center;gap: 100px;justify-content: space-between;width: 86%">
        <div style="display: flex; align-items: flex-start;flex-direction: column;justify-content: center;height: 70px;margin-left: 20px;">
          <strong style="font-size: x-large;color: #1e3273;">
            {{ (hospitalInfo && hospitalInfo.hospitalName) ? hospitalInfo.hospitalName : '华利自在AI诊断平台' }}
          </strong>
          <div class="system-subtitle2">北京国医鸿泰名医名方研究院</div>
        </div>
        <div class="companyInfoList">
          <div class="infoLabel" @mouseover="contactUsCardShow = true,aboutUsCardShow = false">联系我们</div>
<!--          <div class="infoLabel" @mouseover="aboutUsCardShow = true">关于我们</div>-->
          <div class="contactUsCard" v-if="contactUsCardShow" @mouseover="contactUsCardShow = true" @mouseleave="contactUsCardShow = false">
            <div class="contactUsPop">
              <div class="contactUsLabel"><i class="el-icon-phone-outline"></i><span>电话：</span>187 4009 2581(王镆)</div>
              <!-- <div class="contactUsLabel"><i class="el-icon-message"></i><span>邮箱：</span>lingyangxin2021@163.com</div>
              <div class="contactUsLabel"><i class="el-icon-postcard"></i><span>公司官网：</span><span style="color: blue;" @click.stop="openLink('https://lyx-tech.com')">https://lyx-tech.com</span></div>
              <div class="contactUsLabel"><i class="el-icon-message"></i><span>公司地址：</span>辽宁省沈阳市和平区三好街96号B座11层</div> -->
              <!-- <img class="concatImg" src="@/assets/img/concatImg.png" alt="">   -->
            </div>
          </div>
          <div class="aboutUsCard" v-if="aboutUsCardShow" @mouseover="aboutUsCardShow = true,contactUsCardShow = false" @mouseleave="aboutUsCardShow = false">
            <div class="aboutUsPop">
              <div class="businessList">
                <div class="businessItem">App开发</div>
                <div class="businessItem">小程序开发</div>
                <div class="businessItem">网站建设</div>
                <div class="businessItem">解决方案</div>
                <div class="businessItem">项目案例</div>
              </div>
              <div class="splitLine"></div>
              <img class="concatImg" src="@/assets/img/concatImg.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="header-avatar">
        <el-avatar v-if="0" size="medium" :src="getLogo ? getLogo: require('@/assets/img/logo.jpg')"></el-avatar>
        <el-dropdown style="margin-left: 10px">
          <span class="el-dropdown-link">
            {{ userInfo.realName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link to="/userCenter" @click.native="selectMenu({name: 'UserCenter', title: '个人中心'})">个人中心</router-link>
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside width="200px">
          <SideMenu></SideMenu>
      </el-aside>
      <el-main>
        <Tabs></Tabs>
        <div>
          <router-view></router-view>
        </div>
<!--        <div style="margin: 0 15px">-->
<!--          <router-view></router-view>-->
<!--        </div>-->
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import SideMenu from "@/views/inc/SideMenu";
import Tabs from "@/views/inc/Tabs";
export default {
  name: "Home",
  components: {
    SideMenu,
    Tabs,
  },
  computed: {
    getLogo() {
      if (this.hospitalInfo && (this.hospitalInfo.hospitalCode || this.hospitalInfo.hospitalId)) {
        // 使用当前时间戳替代原来的版本号
        const timestamp = Date.now();
        return window.baseURL + `/operation/hospitalLogo/thumbnail/${this.hospitalInfo.hospitalCode ? this.hospitalInfo.hospitalCode : this.hospitalInfo.hospitalId}?v=${timestamp}`
      }
    }
  },
  data() {
    return {
      contactUsCardShow: false,
      aboutUsCardShow: false,
      hospitalInfo: {},
      userInfo: {
        ID: "",
        realName: "",
        avatar: "https://img1.baidu.com/it/u=3108885758,3678256568&fm=26&fmt=auto",
      }
    }
  },
  watch: {
    '$store.state.hospitalIsUpdate': function(val) {
      if (val) {
        if (sessionStorage.getItem("User")) {
          this.hospitalInfo = JSON.parse(sessionStorage.getItem("User"))
          console.log('00000000000', this.hospitalInfo);
        } else if (localStorage.getItem("hospitalInfo")) {
          this.hospitalInfo = JSON.parse(sessionStorage.getItem("hospitalInfo"));
          console.log('111111111', this.hospitalInfo);
        }else {
          console.log('222222222', this.hospitalInfo);

        }
      }
      this.$store.state.hospitalIsUpdate = false
    }
  },
  created() {
    if (sessionStorage.getItem("User")) {
      this.hospitalInfo = JSON.parse(sessionStorage.getItem("User"));
      console.log('tttttt', this.hospitalInfo)
      localStorage.setItem("hospitalInfo", JSON.stringify(this.hospitalInfo));
    } else if (localStorage.getItem("hospitalInfo")) {
      this.hospitalInfo = JSON.parse(sessionStorage.getItem("hospitalInfo"));
    }
    this.getUserInfo();
  },
  mounted() {
   this.init()
  },
  methods: {
    openLink (link) {
      window.open(link);
    },
    init () {
      console.log('ooooaoaoaoaaa',  this.hospitalInfo)
      const userStr = sessionStorage.getItem("User")
      if (userStr) {
        const user = JSON.parse(userStr)
        console.log('00000000000aaaaaaaa', user.hospitalName)
        this.hospitalInfo = user
      } else if (localStorage.getItem("hospitalInfo")) {
        this.hospitalInfo = JSON.parse(localStorage.getItem("hospitalInfo"));
      }
      this.setTitleAndFavicon()
    },
    setTitleAndFavicon() {
      document.title = this.hospitalInfo?.hospitalName || '华利自在AI诊断平台';
      const favicon = document.querySelector('link[rel~="icon"]');
      if (favicon) {
        console.log(favicon.href)
        favicon.href = this.getLogo || `${process.env.BASE_URL}logo.png`;
        console.log('fafafafafafaafaf', favicon.href)
        document.head.appendChild(favicon);
      }

    },
    getUserInfo() {
      // this.$axios.get("/sys/userInfo").then(res => {
      //   this.userInfo = res.data.data;
      // })
      const userData = sessionStorage.getItem("User");
      if (userData && userData !== 'null') {
        this.userInfo = JSON.parse(userData);
      } else {
        this.$router.push("/login")
        // 未登录状态，使用默认值
        this.userInfo = {
          ID: "",
          realName: "游客",
          avatar: "https://img1.baidu.com/it/u=3108885758,3678256568&fm=26&fmt=auto",
        };
      }
    },
    logout() {
      this.$axios.post("/logout").then(res => {
        // localStorage.clear();
        sessionStorage.clear();
        this.$store.commit("resetState");
        this.$router.push("/login");
      })
    },
    selectMenu(item) {
      // 添加标签页
      this.$store.commit("addTab", item);
    }
  }
}
</script>

<style scoped>
.header-avatar {
  position: absolute;
  right: 20px;
  width: auto;
  display: flex;
  align-items: center;
}
.el-avatar--medium {
  border-radius: 6px;
}
.el-header {
  background: var(--header-color);
  color: white;
  display: flex;
  align-items: center;
  padding-left: 0;
  height: 70px !important;
}

.el-header strong {
  color: var(--primary-text-color) !important;
  position: relative;
  font-family: inherit;
}

.logo {
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(220, 20, 60, 0.3);
}
.system-subtitle2{
  font-size: 16px;
  margin: 0;
  letter-spacing: 1px;
  color: var(--primary-text-color);
  top: 16px;
  font-weight: 300;
  font-family: "inherit";
}
.el-dropdown-link {
  color: var(--primary-text-color);
  font-weight: 500;
  cursor: pointer;
}

.el-dropdown-link:hover {
  color: var(--primary-text-color);
}

.el-container {
  padding: 0;
  margin: 0;
  height: 100vh;
}

.el-container:first-child {
  flex-direction: column;
}

.el-container:last-child {
  flex: 1;
  height: calc(100vh - 60px);
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  line-height: 200px;
}

.logo{
  height: 50px;
  width: 50px;
  margin-top: 5px;
  float: left;
  margin-left: 20px;
}

.el-main {
  color: #333;
  padding: 0;
}

a {
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
  height: 100%;
}
.companyInfoList{
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  z-index: 999;
  .infoLabel{
    user-select: none;
    cursor: pointer;
    transition: transform  0.1s ease-out;
    font-size: 14px;
    position: relative;
    z-index: 99999;
    &:hover{
      transform: scale(1.05);
    }
  }

  .contactUsCard{
    position: absolute;
    top: 0px;
    left: -150px;
    padding-top: 30px;
    z-index: 9999;
    .contactUsPop {
      width: 350px;
      background-color: #fff;
      border-radius: 8px;
      border: 1px solid #E3E5E7;
      color: #000;
      padding: 20px;
      font-size: 15px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif;
      font-weight: 500;
      animation: openCard 0.2s ease-in-out forwards;
      position: relative;
      .concatImg {
        height: 90px;
        width: 90px;
        position: absolute;
        right: 20px;
        top: 10px;
      }
      .contactUsLabel{
        width: max-content;
        display: flex;
        align-items: center;
        span {
         min-width:max-content;
        }
      }
      i{
        margin-right: 5px;
      }
    }
  }
  .aboutUsCard{
    position: absolute;
    top: 0px;
    left: -70px;
    padding-top: 30px;
    z-index: 9999;
    .aboutUsPop {
      width: 300px;
      background-color: #fff;
      border-radius: 8px;
      border: 1px solid #E3E5E7;
      color: #000;
      padding: 20px;
      font-size: 15px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 10px;
      font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif;
      font-weight: 500;
      animation: openCard 0.2s ease-in-out forwards;
      height: 100%;
      .businessList {
        display: flex;
        flex-direction: column;
        gap: 15px;
        font-weight: 700;
      }
      .splitLine {
        width: 1px;
        height: 200px;
        background-color: rgba(0,0,0,0.2);
      }
      .concatImg {
        height: 150px;
        width: 150px;
      }
    }
  }
}
@keyframes openCard {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  50% {
    opacity: 0.2;
  }
  80% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
